import styled from "styled-components";
export const HeroIconImage = styled.img `
    width: 52px;
    height: 64px;
`;
export const CategoryBadgeCircle = styled.span `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${(props) => props.$bgColor};
    flex-shrink: 0;
    box-sizing: border-box;
`;
export const CategoryBadgeGlyph = styled.svg `
    width: 16px;
    height: 16px;
    display: block;
    flex-shrink: 0;
`;
